// extracted by mini-css-extract-plugin
export default {"qrFeedback":"QRFeedback_qrFeedback__iIz61","finished":"QRFeedback_finished__wFUws","failed":"QRFeedback_failed__Tx9Xp"};